export function fmt(value, unit) {
  if (value === null || value === undefined) return "—";
  const v = typeof value === "number" ? value : Number(value);
  const n = Number.isInteger(v) ? v.toLocaleString() : v.toLocaleString(undefined, { maximumFractionDigits: 2 });
  switch (unit) {
    case "%": return `${n}%`;
    case "$": return `$${n}`;
    case "K": return `${n}K`;
    case "M": return `${n}M`;
    case "$B": return `${v < 0 ? "-" : ""}$${Math.abs(v).toLocaleString(undefined, { maximumFractionDigits: 1 })}B`;
    default: return `${n}`;
  }
}

export function dirColor(dir) {
  return dir === "UP" ? "text-[#10B981]" : dir === "DOWN" ? "text-[#EF4444]" : "text-[#F59E0B]";
}

export function actionColor(action) {
  if (action === "BUY") return { text: "#10B981", glow: "rgba(16,185,129,0.4)", bg: "rgba(16,185,129,0.12)" };
  if (action === "SELL") return { text: "#EF4444", glow: "rgba(239,68,68,0.4)", bg: "rgba(239,68,68,0.12)" };
  return { text: "#F59E0B", glow: "rgba(245,158,11,0.4)", bg: "rgba(245,158,11,0.12)" };
}

export function relDate(iso) {
  const d = new Date(iso);
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

export function countdown(days) {
  if (days <= 0) return "Due now";
  if (days === 1) return "in 1 day";
  return `in ${days} days`;
}
